<template>
  <div class="article-unit">
    <lr-link
      :to="`/${postTypeRouterPathMap[aricleData.post_type]}/detail/id/${
        aricleData.post_id || aricleData.id
      }`"
      class="article-unit"
      target="_blank"
    >
      <h1
        class="article-unit-title ellipsis"
        v-html="highlightFormat(aricleData.post_title, keyword)"
      ></h1>
    </lr-link>
    <div
      class="article-unit-content"
      v-html="highlightFormat(aricleData.post_excerpt, keyword)"
    ></div>
    <div class="article-unit-expand">
      <span>{{ postTypeNameMap[aricleData.post_type] }}</span>
      <span v-if="aricleData.post_type !== '2'">{{ topCateNameMap[aricleData.top_cate] }}</span>
      <span>{{ aricleData.post_hits | crowd }}阅读</span>
    </div>
  </div>
</template>

<script>
import {
  POST_TYPE_NAME_MAP,
  TOP_CATE_NAME_MAP,
  POST_TYPE_ROUTER_PATH_MAP,
} from '@/common/constant';
import { highlightFormat } from '@/common/utils';
export default {
  props: {
    aricleData: {
      type: Object,
      default: () => {},
    },
    keyword: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      postTypeNameMap: POST_TYPE_NAME_MAP,
      topCateNameMap: TOP_CATE_NAME_MAP,
      postTypeRouterPathMap: POST_TYPE_ROUTER_PATH_MAP,
    };
  },
  methods: {
    highlightFormat,
  },
};
</script>

<style lang="scss" scoped>
.article-unit {
  width: 720px;

  &-title {
    font-weight: 600;
    color: #222226;
    line-height: 25px;
    font-size: 18px;
    margin-bottom: 12px;

    &:hover {
      color: #417ff9;
    }
  }

  &-content {
    font-weight: 400;
    color: #222226;
    line-height: 20px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
    height: 40px;
  }

  &-expand {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      margin-right: 30px;
      font-weight: 400;
      color: #999999;
      font-size: 12px;
    }
  }
}
</style>
